import { core } from '@tock/coretypes';
import { reject } from 'es-toolkit/compat';
import AppConstants from 'constants/AppConstants';

export interface GiftCard {
  number: string;
  pin: string;
  amountCents: number;
  provider: core.Business.GiftCardProvider;
}

interface State {
  giftCards: GiftCard[];
  giftCardRequestInProgress: boolean;
  tockGiftCard?: core.TockGiftCard;
}

// exported for testing
export const initialState: State = {
  giftCards: [],
  giftCardRequestInProgress: false,
  tockGiftCard: undefined,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload, context } = action;
  switch (type) {
    // Gift card states
    case AppConstants.GIFT_CARD_GET_BALANCE_STARTING: {
      return {
        ...state,
        giftCardRequestInProgress: true,
      };
    }
    case AppConstants.GIFT_CARD_GET_BALANCE_DONE:
    case AppConstants.GIFT_CARD_GET_BALANCE_FAILED: {
      return {
        ...state,
        giftCardRequestInProgress: false,
      };
    }
    case AppConstants.APPLY_GIFT_CARD: {
      const giftCards: GiftCard[] = [
        ...state.giftCards,
        {
          number: payload.number,
          pin: payload.pin,
          amountCents: payload.amountCents,
          provider: payload.provider,
        },
      ];
      return {
        ...state,
        giftCardRequestInProgress: false,
        giftCards,
      };
    }
    case AppConstants.REMOVE_GIFT_CARD: {
      const giftCards: GiftCard[] = reject(
        state.giftCards,
        (giftCard) => giftCard.number === context.giftCardNumber
      );
      return {
        ...state,
        giftCards,
      };
    }
    case AppConstants.PAST_PURCHASE_CLEAR: {
      return {
        ...state,
        giftCards: [],
        tockGiftCard: undefined,
      };
    }
    case AppConstants.GIFT_CARD_CLEAR: {
      // clear a specific provider, else clear all
      if (action.payload) {
        const newGiftCards = [...state.giftCards].filter(
          (giftCard) => giftCard.provider !== action.payload
        );
        return {
          ...state,
          giftCards: newGiftCards,
        };
      }
      return {
        ...state,
        giftCards: [],
      };
    }

    case AppConstants.TOCK_GIFT_CARD_ADDED: {
      return {
        ...state,
        tockGiftCard: action.payload as core.TockGiftCard,
      };
    }

    case AppConstants.TOCK_GIFT_CARD_REMOVED: {
      return {
        ...state,
        tockGiftCard: undefined,
      };
    }

    default:
      return state;
  }
}
